module.exports = __webpack_public_path__ + "static/img/6-2.4de13430.jpg";